<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close"></div>
        <div class="loadingIcon" v-if="loading"></div>
        <div class="loadingData" v-if="loadingData"></div>
        <div v-if="changeType === 'top'">
          <div class="plantNav nl" v-on:click="prevPot"
            v-if="topIdx > 1"></div>
          <div class="plantNav nr" v-on:click="nextPot"
            v-if="topIdx < accTops.length + 3"></div>
        </div>
        <div v-else-if="changeType === 'mid'">
          <div class="plantNav nl" v-on:click="prevPot"
            v-if="midIdx > 1"></div>
          <div class="plantNav nr" v-on:click="nextPot"
            v-if="midIdx < accTops.length + 3"></div>
        </div>
        <div v-else-if="changeType === 'bot'">
          <div class="plantNav nl" v-on:click="prevPot"
            v-if="botIdx > 1"></div>
          <div class="plantNav nr" v-on:click="nextPot"
            v-if="botIdx < accTops.length + 3"></div>
        </div>
        <h4 class="title">Ganti aksesoris</h4>
        <div class="tabs">
          <div class="tab left" :class="{active: changeType === 'top'}"
            v-on:click="selectType('top')">Kepala</div>
          <div class="tab center" :class="{active: changeType === 'mid'}"
            v-on:click="selectType('mid')">Muka</div>
          <div class="tab right" :class="{active: changeType === 'bot'}"
            v-on:click="selectType('bot')">Badan</div>
        </div>
        <div class="plant" :class="[`top${topIdx}`, `mid${midIdx}`, `bot${botIdx}`, changeType]">
          <div class="charImg" :class="[selectedChar, bmiType]"></div>
          <div class="accSc top">
            <div class="accItem act0 none"
              :class="{selected: accTop === 'none'}"></div>
            <div class="accItem act1 default1"
              :class="{selected: accTop === 'default1'}"></div>
            <div class="accItem act2 default2"
              :class="{selected: accTop === 'default2'}"></div>
            <div class="accItem" v-for="(item, i) in accTops" :key="i"
              :class="[{selected: accTop === item.uid},
                {disabled: point < item.point || !item.claimed},
                item.uid, `act${i+3}`]">
              <span class="span" v-if="point < item.point">Terbuka<br />di {{item.point}}pt</span>
              <div class="span" v-else-if="item.locked">
                <div>
                  <img src="../assets/locked-black.png">
                  Locked
                </div>
              </div>
              <span class="span" v-else-if="!item.claimed">Unclaimed</span>
              <span class="info" v-if="item.uid === 'astro'">Baju astronot tidak bisa digunakan
                dengan aksesoris lain</span>
            </div>
          </div>
          <div class="accSc mid">
            <div class="accItem act0 none"
              :class="{selected: accMid === 'none'}"></div>
            <div class="accItem act1 default1"
              :class="{selected: accMid === 'default1'}"></div>
            <div class="accItem act2 default2"
              :class="{selected: accMid === 'default2'}"></div>
            <div class="accItem" v-for="(item, i) in accTops" :key="i"
              :class="[{selected: accMid === item.uid},
                {disabled: point < item.point || !item.claimed},
                item.uid, `act${i+3}`]">
              <span class="span" v-if="point < item.point">Terbuka<br />di {{item.point}}pt</span>
              <div class="span" v-else-if="item.locked">
                <div>
                  <img src="../assets/locked-black.png">
                  Locked
                </div>
              </div>
              <span class="span" v-else-if="!item.claimed">Unclaimed</span>
            </div>
          </div>
          <div class="accSc bot">
            <div class="accItem act0 none"
              :class="{selected: accBot === 'none'}"></div>
            <div class="accItem act1 default1"
              :class="{selected: accBot === 'default1'}"></div>
            <div class="accItem act2 default2"
              :class="{selected: accBot === 'default2'}"></div>
            <div class="accItem" v-for="(item, i) in accTops" :key="i"
              :class="[{selected: accBot === item.uid},
                {disabled: point < item.point || !item.claimed},
                item.uid, `act${i+3}`]">
              <span class="span" v-if="point < item.point">Terbuka<br />di {{item.point}}pt</span>
              <div class="span" v-else-if="item.locked">
                <div>
                  <img src="../assets/locked-black.png">
                  Locked
                </div>
              </div>
              <span class="span" v-else-if="!item.claimed">Unclaimed</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'confirmation',
  data() {
    return {
      show: false,
      next: null,
      selectedChar: 'nunu',
      bmiType: '',
      point: 0,
      loading: false,
      loadingData: true,
      topIdx: 1,
      botIdx: 1,
      midIdx: 1,
      changeType: 'top',
      timer: null,
      saveTimeout: null,

      /**
       * Acc
       *
       */
      accTop: 'none',
      accMid: 'none',
      accBot: 'none',
      accTops: [],
      accMids: [],
      accBots: [],
    };
  },
  methods: {
    open(d, next) {
      this.loading = false;
      this.loadingData = true;
      this.selectedChar = this.$session.get('bk6_character') || 'nunu';
      this.bmiType = this.$session.get('bk6_bmiType') || 'normal';
      this.point = this.$session.get('bk6_point') || 0;
      this.accTop = this.$session.get('bk6_accTop') || 'none';
      this.accMid = this.$session.get('bk6_accMid') || 'none';
      this.accBot = this.$session.get('bk6_accBot') || 'none';
      this.$http.get(this.$config.uri('user/acc/top')).then((r) => {
        this.accTops = (r.data.status === 200) ? r.data.data : [];
        if (this.accTop === 'none') {
          this.topIdx = 1;
        } else if (this.accTop === 'default1') {
          this.topIdx = 2;
        } else if (this.accTop === 'default2') {
          this.topIdx = 3;
        } else {
          let i = 4;
          // eslint-disable-next-line
          for (const item of this.accTops) {
            if (item.uid === this.accTop) {
              this.topIdx = i;
              break;
            }
            i += 1;
          }
        }
        this.$http.get(this.$config.uri('user/acc/mid')).then((r2) => {
          this.accMids = (r2.data.status === 200) ? r2.data.data : [];
          if (this.accMid === 'none') {
            this.midIdx = 1;
          } else if (this.accMid === 'default1') {
            this.midIdx = 2;
          } else if (this.accMid === 'default2') {
            this.midIdx = 3;
          } else {
            let i = 4;
            // eslint-disable-next-line
            for (const item of this.accMids) {
              if (item.uid === this.accMid) {
                this.midIdx = i;
                break;
              }
              i += 1;
            }
          }
          this.$http.get(this.$config.uri('user/acc/bot')).then((r3) => {
            this.accBots = (r3.data.status === 200) ? r3.data.data : [];
            if (this.accBot === 'none') {
              this.botIdx = 1;
            } else if (this.accBot === 'default1') {
              this.botIdx = 2;
            } else if (this.accBot === 'default2') {
              this.botIdx = 3;
            } else {
              let i = 4;
              // eslint-disable-next-line
              for (const item of this.accBots) {
                if (item.uid === this.accBot) {
                  this.botIdx = i;
                  break;
                }
                i += 1;
              }
            }
            if (this.timer) clearTimeout(this.timer);
            this.timer = setTimeout(() => {
              this.loadingData = false;
            }, 200);
          });
        });
      });
      this.next = next;
      this.show = true;
    },
    selectType(type) {
      this.loadingData = true;
      this.changeType = type;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.loadingData = false;
      }, 400);
    },
    close(b) {
      this.show = false;
      if (this.point >= 1240) {
        if (this.accTop === 'astro' || this.accBot === 'astro' || this.accMid === 'astro') {
          this.$session.set('bk6_accTop', 'astro');
          this.$session.set('bk6_accMid', 'none');
          this.$session.set('bk6_accBot', 'none');
          this.$session.set('bk6_bg', 'bg4');
          this.$http.post(this.$config.uri('user/set/acc'), {
            accTop: 'astro',
            accMid: 'none',
            accBot: 'none',
          }).then((r) => {});
        } else if (this.$session.get('bk6_bg') === 'bg4') {
          this.$session.set('bk6_bg', 'bg3');
        }
      }
      if (this.next && typeof this.next === 'function') this.next(b);
    },
    prevPot() {
      if (this.changeType === 'top') {
        if (this.topIdx === 1) return;
        this.topIdx -= 1;
      } else if (this.changeType === 'mid') {
        if (this.midIdx === 1) return;
        this.midIdx -= 1;
      } else if (this.changeType === 'bot') {
        if (this.botIdx === 1) return;
        this.botIdx -= 1;
      }
      this.saveChanges();
    },
    nextPot() {
      if (this.changeType === 'top') {
        if (this.topIdx === this.accTops.length + 3) return;
        this.topIdx += 1;
      } else if (this.changeType === 'mid') {
        if (this.midIdx === this.accTops.length + 3) return;
        this.midIdx += 1;
      } else if (this.changeType === 'bot') {
        if (this.botIdx === this.accTops.length + 3) return;
        this.botIdx += 1;
      }
      this.saveChanges();
    },
    saveChanges() {
      if (this.changeType === 'top') {
        if (this.topIdx === 1) {
          this.accTop = 'none';
        } else if (this.topIdx === 2) {
          this.accTop = 'default1';
        } else if (this.topIdx === 3) {
          this.accTop = 'default2';
        } else {
          this.accTop = this.accTops[this.topIdx - 4].uid;
        }
      } else if (this.changeType === 'mid') {
        if (this.midIdx === 1) {
          this.accMid = 'none';
        } else if (this.midIdx === 2) {
          this.accMid = 'default1';
        } else if (this.midIdx === 3) {
          this.accMid = 'default2';
        } else {
          this.accMid = this.accMids[this.midIdx - 4].uid;
        }
      } else if (this.changeType === 'bot') {
        if (this.botIdx === 1) {
          this.accBot = 'none';
        } else if (this.botIdx === 2) {
          this.accBot = 'default1';
        } else if (this.botIdx === 3) {
          this.accBot = 'default2';
        } else {
          this.accBot = this.accBots[this.botIdx - 4].uid;
        }
      }
      if (this.loading) return;
      let accTop;
      if (this.topIdx > 3) {
        const at = this.accTops[this.topIdx - 4];
        accTop = (!at.claimed || this.point < at.point || at.locked)
          ? this.$session.get('bk6_accTop') : at.uid;
      } else {
        accTop = this.accTop; // eslint-disable-line
      }
      let accMid;
      if (this.midIdx > 3) {
        const at = this.accMids[this.midIdx - 4];
        accMid = (!at.claimed || this.point < at.point || at.locked)
          ? this.$session.get('bk6_accMid') : at.uid;
      } else {
        accMid = this.accMid; // eslint-disable-line
      }
      let accBot;
      if (this.botIdx > 3) {
        const at = this.accBots[this.botIdx - 4];
        accBot = (!at.claimed || this.point < at.point || at.locked)
          ? this.$session.get('bk6_accBot') : at.uid;
      } else {
        accBot = this.accBot; // eslint-disable-line
      }
      this.$session.set('bk6_accTop', accTop);
      this.$session.set('bk6_accMid', accMid);
      this.$session.set('bk6_accBot', accBot);
      clearTimeout(this.saveTimeout);
      this.saveTimeout = setTimeout(() => {
        this.loading = true;
        this.$http.post(this.$config.uri('user/set/acc'), { accTop, accMid, accBot }).then((r) => {
          this.loading = false;
        });
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 9997;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      background-color: #e6e1c1;

      background-color: #b7e4c9;
      background-image: linear-gradient(#fff 0, #e2fcec 50%, #fff);

      z-index: 2;
      padding: 40px 20px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      width: 640px;
      // background-image: url(../assets/modal-bg2.jpg);
      background-size: auto 100%;
      background-position: left;
      background-repeat: no-repeat;
      text-align: center;
      @media (max-width: 740px) {
        width: auto;
        left: 10px; right: 10px;
      }
      .title{
        margin: 0;
        display: none;
      }
      .tabs{
        display: flex;
        position: absolute;
        left: 50%; top: 20px;
        width: 240px;
        margin-left: -120px;
        z-index: 9;
        .tab{
          font-size: 16px;
          padding: 10px;
          width: 33.333333%;
          box-sizing: border-box;
          background-color: rgba(255, 255, 255, .45);
          background-color: #eee;
          color: #444;
          transition: all .3s ease;
          cursor: pointer;
          &:hover{
            background-color: #fff;
            background-color: #e5e5e5;
          }
          &.active{
            background-color: #f76b21;
            color: #fff;
          }
          &.left{
            border-radius: 50px 0 0 50px;
            padding-right: 0;
          }
          &.right{
            border-radius: 0 50px 50px 0;
            padding-left: 0;
          }
          &.center{
            padding: 10px 0;
            border-radius: 0;
          }
        }
      }
      .close{
        width: 36px; height: 36px;
        border-radius: 50%;
        position: absolute;
        right: 10px; top: 10px;
        background-image: url(../assets/close.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .7;
        cursor: pointer;
        transition: all .3s ease;
        z-index: 17;
        &:hover{
          background-color: rgba(0,0,0,.2);
          opacity: .6;
        }
      }
      .loadingData{
        background-color: #e6e1c1;
        background-color: #fff;
        position: absolute;
        left: 0; top: 0; right: 0; bottom: 0;
        z-index: 11;
        background-size: 46px auto;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(../assets/loading.svg);
      }
      .loadingIcon{
        width: 36px; height: 36px;
        border-radius: 50%;
        position: absolute;
        right: 46px; top: 10px;
        background-image: url(../assets/loading.svg);
        background-size: 24px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .7;
        z-index: 7;
      }
      .plantNav{
        position: absolute;
        top: 0; bottom: 0;
        width: calc(50% - 100px);
        cursor: pointer;
        z-index: 4;
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .2;
        transition: all .3s ease;
        @media (max-width: 680px) {
          width: calc(50% - 80px);
        }
        &:hover{
          opacity: .56;
          transition: all .3s ease;
        }
        &.nl{
          left: 0;
          background-image: url(../assets/left-arrow.png);
        }
        &.nr{
          right: 0;
          background-image: url(../assets/right-arrow.png);
        }
      }
      .plant{
        height: 400px; width: 300px;
        margin: 0 auto;
        position: relative;
        z-index: 3;
        @media (max-width: 680px) {
          height: 340px;
        }
        .charImg{
          position: absolute;
          left: 0; right: 0; top: 0; bottom: 0;
          background-image: url(../assets/char/nunu-normal-1.png);
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          z-index: 3;
          &.kurus{
            background-image: url(../assets/char/nunu-kurus-1.png);
          }
          &.gemuk{
            background-image: url(../assets/char/nunu-gemuk-1.png);
          }
          &.lili{
            background-image: url(../assets/char/lili-normal-1.png);
            &.kurus{
              background-image: url(../assets/char/lili-kurus-1.png);
            }
            &.gemuk{
              background-image: url(../assets/char/lili-gemuk-1.png);
            }
          }
        }
        .accSc{
          width: 1600%;
          position: absolute;
          left: 0; top: 0; bottom: 0;
          display: flex; z-index: 4;
          transition: all .3s ease;
          .accItem{
            transition: all .3s ease;
            height: 100%; width: 11%;
            position: relative;
            visibility: hidden;
            &.selected{ visibility: visible !important; }
            &:before{
              content: "";
              position: absolute;
              left: 0; top: 0; right: 0; bottom: 0;
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
            }
            .info{
              position: absolute;
              left: 10px; right: 10px; bottom: 20px;
              font-size: 12px;
              display: none;
            }
            .span{
              position: absolute;
              left: 0; right: 0; top: 36px;
              text-align: center;
              color: #444; display: none;
              font-size: 12px;
              z-index: 3;
              display: none;
              img{
                display: block;
                margin: 0 auto 6px;
                height: 26px;
              }
            }
            &.disabled{
              &:before{
                filter: brightness(0);
              }
            }
          }
          &.top{
            .accItem{
              &.default1:before{ background-image: url(../assets/acc/acc-winter-atas-1.png); }
              &.default2:before{ background-image: url(../assets/acc/acc-summer-atas-1.png); }
              &.badut:before{ background-image: url(../assets/acc/acc-badut-atas-1.png); }
              &.indo:before{ background-image: url(../assets/acc/acc-indo-atas-1.png); }
              &.gym:before{ background-image: url(../assets/acc/acc-gym-atas-1.png); }
              &.sekolah:before{ background-image: url(../assets/acc/acc-sekolah-atas-1.png); }
              &.farmer:before{ background-image: url(../assets/acc/acc-petani-atas-1.png); }
              &.gym2:before{ background-image: url(../assets/acc/acc-gym2-atas-1.png); }
              &.lab:before{ background-image: url(../assets/acc/acc-lab-atas-1.png); }
              &.bodykey:before{ background-image: url(../assets/acc/acc-bk-atas-1.png); }
              &.bodykey:before{ background-image: url(../assets/acc/acc-bk-atas-1.png); }
              &.AI30-1:before{ background-image: url(../assets/acc/acc-AI30-1-atas.png); }
              &.astro:before{ background-image: url(../assets/acc/acc-astro-1.png); }
              &.indo2:before{ background-image: url(../assets/acc/acc-indo2-1-atas.png); }
              &.paskib1:before{ background-image: url(../assets/acc/acc-paskib-1-atas.png); }
              &.hero1:before{ background-image: url(../assets/acc/acc-pahlawan-1-atas.png); }
            }
          }
          &.mid{
            .accItem{
              &.default1:before{ background-image: url(../assets/acc/acc-winter-tengah-1.png); }
              &.default2:before{ background-image: url(../assets/acc/acc-summer-tengah-1.png); }
              &.badut:before{ background-image: url(../assets/acc/acc-badut-tengah-1.png); }
              &.indo:before{ background-image: url(../assets/acc/acc-indo-tengah-1.png); }
              &.gym:before{ background-image: url(../assets/acc/acc-gym-tengah-1.png); }
              &.sekolah:before{ background-image: url(../assets/acc/acc-sekolah-tengah-1.png); }
              &.farmer:before{ background-image: url(../assets/acc/acc-petani-tengah-1.png); }
              &.gym2:before{ background-image: url(../assets/acc/acc-gym2-tengah-1.png); }
              &.lab:before{ background-image: url(../assets/acc/acc-lab-tengah-1.png); }
              &.bodykey:before{ background-image: url(../assets/acc/acc-bk-tengah-1.png); }
              &.AI30-1:before{ background-image: url(../assets/acc/acc-AI30-1-tengah.png); }
              &.astro:before{ background-image: url(../assets/acc/acc-astro-1.png); }
              &.indo2:before{ background-image: url(../assets/acc/acc-indo2-1-tengah.png); }
              &.paskib1:before{ background-image: url(../assets/acc/acc-paskib-1-tengah.png); }
              &.hero1:before{ background-image: url(../assets/acc/acc-pahlawan-1-tengah.png); }
            }
          }
          &.bot{
            .accItem{
              &.default1:before{ background-image: url(../assets/acc/acc-winter-bawah-1.png); }
              &.default2:before{ background-image: url(../assets/acc/acc-summer-bawah-1.png); }
              &.badut:before{ background-image: url(../assets/acc/acc-badut-bawah-1.png); }
              &.indo:before{ background-image: url(../assets/acc/acc-indo-bawah-1.png); }
              &.gym:before{ background-image: url(../assets/acc/acc-gym-bawah-1.png); }
              &.sekolah:before{ background-image: url(../assets/acc/acc-sekolah-bawah-1.png); }
              &.farmer:before{ background-image: url(../assets/acc/acc-petani-bawah-1.png); }
              &.gym2:before{ background-image: url(../assets/acc/acc-gym2-bawah-1.png); }
              &.lab:before{ background-image: url(../assets/acc/acc-lab-bawah-1.png); }
              &.bodykey:before{ background-image: url(../assets/acc/acc-bk-bawah-1.png); }
              &.AI30-1:before{ background-image: url(../assets/acc/acc-AI30-1-bawah.png); }
              &.astro:before{ background-image: url(../assets/acc/acc-astro-1.png); }
              &.indo2:before{ background-image: url(../assets/acc/acc-indo2-1-bawah.png); }
              &.paskib1:before{ background-image: url(../assets/acc/acc-paskib-1-bawah.png); }
              &.hero1:before{ background-image: url(../assets/acc/acc-pahlawan-1-bawah.png); }
            }
          }
        }
        &.top .accSc.top .accItem{ visibility: visible; .span{ display:block; } }
        &.top1 .accSc.top{
          .act1{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top2 .accSc.top{
          margin-left: -100%;
          .act0{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act2{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top3 .accSc.top{
          margin-left: -200%;
          .act1{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px; }
          .act3{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px; }
        }
        &.top4 .accSc.top{
          margin-left: -300%;
          .act2{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act4{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top5 .accSc.top{
          margin-left: -400%;
          .act3{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act5{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top6 .accSc.top{
          margin-left: -500%;
          .act4{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act6{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top7 .accSc.top{
          margin-left: -600%;
          .act5{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act7{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top8 .accSc.top{
          margin-left: -700%;
          .act6{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act8{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top9 .accSc.top{
          margin-left: -800%;
          .act7{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act9{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top10 .accSc.top{
          margin-left: -900%;
          .act8{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act11{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top11 .accSc.top{
          margin-left: -1000%;
          .act9{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act11{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top12 .accSc.top{
          margin-left: -1100%;
          .act10{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act12{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top13 .accSc.top{
          margin-left: -1200%;
          .act11{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act13{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top14 .accSc.top{
          margin-left: -1300%;
          .act12{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act14{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top15 .accSc.top{
          margin-left: -1400%;
          .act13{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act15{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top16 .accSc.top{
          margin-left: -1500%;
          .act14{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act16{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top17 .accSc.top{
          margin-left: -1600%;
          .act15{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act17{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top18 .accSc.top{
          margin-left: -1700%;
          .act16{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act18{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top19 .accSc.top{
          margin-left: -1800%;
          .act17{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act19{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top20 .accSc.top{
          margin-left: -1900%;
          .act18{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act20{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top21 .accSc.top{
          margin-left: -2000%;
          .act19{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act21{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.top22 .accSc.top{
          margin-left: -2100%;
          .act20{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act22{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid .accSc.mid .accItem{ visibility: visible; .span{ display:block; } }
        &.mid1 .accSc.mid{
          .act1{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid2 .accSc.mid{
          margin-left: -100%;
          .act0{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act2{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid3 .accSc.mid{
          margin-left: -200%;
          .act1{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px; }
          .act3{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px; }
        }
        &.mid4 .accSc.mid{
          margin-left: -300%;
          .act2{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act4{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid5 .accSc.mid{
          margin-left: -400%;
          .act3{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act5{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid6 .accSc.mid{
          margin-left: -500%;
          .act4{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act6{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid7 .accSc.mid{
          margin-left: -600%;
          .act5{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act7{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid8 .accSc.mid{
          margin-left: -700%;
          .act6{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act8{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid9 .accSc.mid{
          margin-left: -800%;
          .act7{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act9{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid10 .accSc.mid{
          margin-left: -900%;
          .act8{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act11{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid11 .accSc.mid{
          margin-left: -1000%;
          .act9{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act11{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid12 .accSc.mid{
          margin-left: -1100%;
          .act10{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act12{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid13 .accSc.mid{
          margin-left: -1200%;
          .act11{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act13{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid14 .accSc.mid{
          margin-left: -1300%;
          .act12{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act14{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid15 .accSc.mid{
          margin-left: -1400%;
          .act13{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act15{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid16 .accSc.mid{
          margin-left: -1500%;
          .act14{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act16{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid17 .accSc.mid{
          margin-left: -1600%;
          .act15{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act17{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid18 .accSc.mid{
          margin-left: -1700%;
          .act16{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act18{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid19 .accSc.mid{
          margin-left: -1800%;
          .act17{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act19{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid20 .accSc.mid{
          margin-left: -1900%;
          .act18{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act20{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid21 .accSc.mid{
          margin-left: -2000%;
          .act19{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act21{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.mid22 .accSc.mid{
          margin-left: -2100%;
          .act20{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act22{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot .accSc.bot .accItem{ visibility: visible; .span{ display:block; } }
        &.bot1 .accSc.bot{
          .act1{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot2 .accSc.bot{
          margin-left: -100%;
          .act0{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act2{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot3 .accSc.bot{
          margin-left: -200%;
          .act1{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px; }
          .act3{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px; }
        }
        &.bot4 .accSc.bot{
          margin-left: -300%;
          .act2{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act4{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot5 .accSc.bot{
          margin-left: -400%;
          .act3{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act5{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot6 .accSc.bot{
          margin-left: -500%;
          .act4{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act6{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot7 .accSc.bot{
          margin-left: -600%;
          .act5{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act7{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot8 .accSc.bot{
          margin-left: -700%;
          .act6{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act8{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot9 .accSc.bot{
          margin-left: -800%;
          .act7{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act9{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot10 .accSc.bot{
          margin-left: -900%;
          .act8{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act11{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot11 .accSc.bot{
          margin-left: -1000%;
          .act9{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act11{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot12 .accSc.bot{
          margin-left: -1100%;
          .act10{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act12{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot13 .accSc.bot{
          margin-left: -1200%;
          .act11{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act13{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot14 .accSc.bot{
          margin-left: -1300%;
          .act12{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act14{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot15 .accSc.bot{
          margin-left: -1400%;
          .act13{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act15{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot16 .accSc.bot{
          margin-left: -1500%;
          .act14{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act16{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot17 .accSc.bot{
          margin-left: -1600%;
          .act15{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act17{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot18 .accSc.bot{
          margin-left: -1700%;
          .act16{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act18{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot19 .accSc.bot{
          margin-left: -1800%;
          .act17{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act19{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot20 .accSc.bot{
          margin-left: -1900%;
          .act18{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act20{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot21 .accSc.bot{
          margin-left: -2000%;
          .act19{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act21{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
        &.bot22 .accSc.bot{
          margin-left: -2100%;
          .act20{ transform: scale(.65) translateX(42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
          .act22{ transform: scale(.65) translateX(-42%); background-color: rgba(0, 0, 0, .1);
            border-radius: 10px;  }
        }
      }
    }
  }
</style>
